import { defineComponent as _defineComponent } from 'vue'
import VaccineStatus from '@/components/vaccine-status.vue';
import DoggoImage from '@busy-human/k9-library/src/resources/doggo.svg';
import DocRefImage from './doc-ref-image.vue';
import { DataInstance } from '@busy-human/gearbox';
import { Dogspaces } from '@busy-human/k9-library';

type Props = {
    dog: DataInstance<Dogspaces.Model>
}

export default /*@__PURE__*/_defineComponent({
  __name: 'dog-card',
  props: {
    dog: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();




const __returned__ = { VaccineStatus, get DoggoImage() { return DoggoImage }, DocRefImage, get DataInstance() { return DataInstance }, get Dogspaces() { return Dogspaces } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})